module.exports = __webpack_public_path__ + "img/join2.180dfea5.png";